<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="语言" required class="locale-select-item">
        <a-select
          mode="multiple"
          v-model="selectedLocales"
          placeholder="请选择语言"
          class="locale-select"
          :maxTagCount="4"
          :allowClear="false"
          @change="handleLocaleChange"
        >
          <a-select-option v-for="item in titleFields" :key="item.key" :value="item.key">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <div v-for="item in visibleTitleFields" :key="item.key" class="locale-block">
        <a-form-model-item
          :label="item.label + '标题'"
          :prop="item.prop"
          class="locale-name-item"
        >
          <a-input
            class="locale-name-input"
            v-model="form[item.prop]"
            :placeholder="'请输入' + item.label + '标题'"
          />
        </a-form-model-item>
      </div>

      <a-form-model-item label="排序(正序)" prop="sort">
        <a-input-number :min="0" :precision="0" v-model="form.sort" placeholder="请输入排序(正序)" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTag, addTag, updateTag } from '@/api/video/tag'
import elColorPicker from 'el-color-picker'
import UploadFileToVOD from '@/api/vod.js'

const TITLE_FIELDS = [
  { key: 'zh', label: '中文简体', prop: 'tagTitle' },
  { key: 'tc', label: '中文繁体', prop: 'tagTitleTc' },
  { key: 'en', label: '英文', prop: 'tagTitleEn' },
  { key: 'jp', label: '日语', prop: 'tagTitleJp' },
  { key: 'ko', label: '韩语', prop: 'tagTitleKo' },
  { key: 'fr', label: '法语', prop: 'tagTitleFr' },
  { key: 'ab', label: '阿拉伯语', prop: 'tagTitleAb' },
  { key: 'vi', label: '越南语', prop: 'tagTitleVi' }
]

const DEFAULT_SELECTED_LOCALES = ['zh']

const buildTitleForm = () => {
  const fields = {}
  TITLE_FIELDS.forEach(item => {
    fields[item.prop] = null
  })
  return fields
}

const buildTitleRules = () => {
  const rules = {}
  TITLE_FIELDS.forEach(item => {
    rules[item.prop] = []
  })
  return rules
}

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    elColorPicker
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      uploadLoading: false,
      titleFields: TITLE_FIELDS,
      selectedLocales: [...DEFAULT_SELECTED_LOCALES],
      // 表单参数
      form: {
        id: null,
        ...buildTitleForm(),
        sort: null,
        imgUrl: null,
        colors: null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        ...buildTitleRules(),
        imgUrl: [
          { required: false, message: '请上传背景图', trigger: 'change' }
        ],
        colors: [
          { required: false, message: '请选择颜色' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    visibleTitleFields () {
      return this.titleFields.filter(item => this.selectedLocales.includes(item.key))
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleLocaleChange (value) {
      if (!value || value.length === 0) {
        this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
        this.$message.warning('请至少选择一种语言')
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    resolveSelectedLocalesFromData (data) {
      const keys = TITLE_FIELDS
        .filter(item => data && data[item.prop])
        .map(item => item.key)
      return keys.length ? keys : [...DEFAULT_SELECTED_LOCALES]
    },
    validateLocaleContent () {
      if (!this.selectedLocales || this.selectedLocales.length === 0) {
        this.$message.error('请至少选择一种语言')
        return false
      }
      const hasOneFilled = this.visibleTitleFields.some(item => !!(this.form[item.prop] && String(this.form[item.prop]).trim()))
      if (!hasOneFilled) {
        this.$message.error('至少选择一种语言填写标题，不能全部为空')
        return false
      }
      return true
    },
    loadFormFromApi (data) {
      const form = {
        id: null,
        ...buildTitleForm(),
        sort: null,
        imgUrl: null,
        colors: null,
        createTime: null,
        remark: null,
        ...(data || {})
      }
      TITLE_FIELDS.forEach(item => {
        form[item.prop] = data && data[item.prop] != null ? data[item.prop] : ''
      })
      this.form = form
      this.selectedLocales = this.resolveSelectedLocalesFromData(form)
    },
    onClose () {
      this.open = false
      this.reset()
    },

    handleChange(info) {
      const that = this
      that.uploadLoading = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.imgUrl = fileName[0]// 文件名
          that.uploadLoading = false
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('imgUrl')
            }
          })
        },
        error: function () {
          that.uploadLoading = false
          that.$message.error('上传失败，请重试')
        }
      })
    },
    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading = false
        return false
      }
      this.form.imgUrl = ''
      this.uploadLoading = true
      // TODO 驗證文件大小
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
      this.form = {
        id: null,
        ...buildTitleForm(),
        sort: null,
        imgUrl: null,
        colors: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.form.colors = ''
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTag({ 'id': id }).then(response => {
        this.loadFormFromApi(response.data)
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        if (!this.validateLocaleContent()) {
          return false
        }
        this.submitLoading = true
        if (this.form.id !== undefined && this.form.id !== null) {
          updateTag(this.form).then(response => {
            this.$message.success(
              '修改成功',
              3
            )
            this.open = false
            this.$emit('ok')
            this.reset()
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          addTag(this.form).then(response => {
            this.$message.success(
              '新增成功',
              3
            )
            this.open = false
            this.$emit('ok')
            this.reset()
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.locale-select-item {
  :deep(.ant-form-item-control) {
    line-height: 1.5;
  }
}

.locale-select {
  width: 520px;
  max-width: 100%;

  :deep(.ant-select-selection) {
    min-height: 40px;
    padding: 4px 8px;
    border-radius: 6px;
  }

  :deep(.ant-select-selection--multiple .ant-select-selection__choice) {
    height: 28px;
    line-height: 26px;
    margin: 2px 4px 2px 0;
    padding: 0 8px;
    border-radius: 4px;
    background: #f0f5ff;
    border-color: #d6e4ff;
    color: #2f54eb;
  }

  :deep(.ant-select-selection--multiple .ant-select-selection__rendered) {
    margin-left: 4px;
    line-height: 30px;
  }
}

.locale-block {
  padding: 12px 16px 4px;
  margin-bottom: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
}

.locale-name-item {
  :deep(.ant-form-item-control) {
    line-height: 40px;
  }
}

.locale-name-input {
  width: 420px;
  max-width: 100%;
}

.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
